
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 155","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.005 14.531c0 8.026-6.719 14.531-15 14.531-8.282 0-15.002-6.505-15.002-14.53C35.003 6.505 41.723 0 50.004 0c8.282 0 15.001 6.506 15.001 14.531zm-17.5 92.031v38.75c0 5.359-4.47 9.688-10.001 9.688-5.532 0-10.001-4.329-10.001-9.688v-67.54l-8.929 14.41c-2.844 4.572-8.988 6.055-13.722 3.3-4.735-2.754-6.267-8.688-3.422-13.29l18.213-29.335c5.422-8.749 15.173-14.107 25.705-14.107h9.313c10.532 0 20.282 5.358 25.72 14.107L98.57 82.192c2.844 4.602 1.312 10.536-3.407 13.29-4.75 2.755-10.875 1.272-13.72-3.3l-8.937-14.41v67.54c0 5.359-4.47 9.688-10 9.688-5.532 0-10.002-4.329-10.002-9.688v-38.75h-5z","fill":"currentColor"}})])
          )
        }
      }
    